import {
  House,
  Users,
  ChartNoAxesCombined,
  Activity,
  BanknoteArrowUp,
  ShoppingCart,
  ScanFace,
  FileBox,
} from "lucide-react";

export interface AgentSidebarLink {
  id: string;
  path: string;
  label: string;
  icon: React.ReactNode;
}

export const agentSidebarLinks: AgentSidebarLink[] = [
  {
    id: "agent-dashboard",
    path: "/dashboard",
    label: "Dashboard",
    icon: <House size={16} />,
  },
  {
    id: "agent-transaction-stats",
    path: "/transaction-stats",
    label: "Transaction Stats",
    icon: <ChartNoAxesCombined size={16} />,
  },
  {
    id: "agent-live-transactions",
    path: "/live-transactions",
    label: "Live Transactions",
    icon: <Activity size={16} />,
  },
  {
    id: "agent-positions",
    path: "/positions",
    label: "Positions",
    icon: <FileBox size={16} />,
  },
  {
    id: "agent-clients",
    path: "/clients",
    label: "My Clients",
    icon: <Users size={16} />,
  },
  {
    id: "agent-kyc",
    path: "/kyc",
    label: "KYC",
    icon: <ScanFace size={16} />,
  },
  {
    id: "agent-withdrawals",
    path: "/withdrawals",
    label: "WithDrawals",
    icon: <BanknoteArrowUp size={16} />,
  },
  {
    id: "agent-esouq-orders",
    path: "/esouq-orders",
    label: "E-Souq Orders",
    icon: <ShoppingCart size={16} />,
  },
];
